export default __webpack_public_path__ + "static/banner-the-reality-of-work-and-travel-marrakech-8859a7cbdd6f6d09b7dc9669c3f0fde8.jpg";